module.exports = __webpack_public_path__ + "img/error-dark.59b0f8e0.svg";